import { Component, OnInit } from '@angular/core';
import { RelatedSolutionsService } from './related-solutions.service';

@Component({
  selector: 'related-solutions',
  templateUrl: './related-solutions.component.html',
  styleUrls: ['./related-solutions.component.css']
})
export class RelatedSolutionsComponent implements OnInit {

  constructor(private relatedSolutionsService: RelatedSolutionsService) {
  }

  ngOnInit(): void {
   
  }


}
